module.exports = __webpack_public_path__ + "static/img/weixin-code.8785f59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/weixin-code.png
// module id = QHdT
// module chunks = 0